import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { AppBar, Container, Grid, IconButton, Toolbar } from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SettingsIcon from '@mui/icons-material/Settings';
import HouseIcon from '@mui/icons-material/House';

import appdata from '../../Services/appdata';
import img1 from '../../Assets/image/logo1.jpg';
import './style.css';

const MainPage = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const user = appdata.getItem('user');
    const roles = appdata.getItem('changedrole').pages;

    setIsAdmin(user.is_admin);
    setRoles(roles);
  }, []);

  const onSignout = () => {
    appdata.localClear();
    appdata.clear();
  };

  return (
    <div>
      <AppBar position="fixed" color="default">
        <Toolbar>
          <IconButton onClick={() => navigate('/')}>
            <HouseIcon />
          </IconButton>
          <IconButton onClick={onSignout} className="sign-out-but">
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" className="main-page-container">
        {isAdmin !== true && roles.length > 0 && (
          <Grid container spacing={3} justifyContent="center">
            {roles.indexOf('Strategy') > -1 && (
              <Grid size={{ sm: 6, md: 3 }}>
                <div
                  className="card"
                  onClick={() => navigate('/home/strategy')}
                >
                  <AppsIcon
                    style={{ fontSize: 198, color: 'rgb(237 0 140)' }}
                  />
                  <div
                    className="text"
                    style={{ backgroundColor: 'rgb(237 0 140)' }}
                  >
                    Strategy
                  </div>
                </div>
              </Grid>
            )}
            {roles.indexOf('ManagementReporting') > -1 && (
              <Grid size={{ sm: 6, md: 3 }}>
                <div
                  className="card"
                  onClick={() => navigate('/home/reporting')}
                >
                  <AssessmentIcon
                    style={{ fontSize: 198, color: 'rgb(140 198 62)' }}
                  />
                  <div
                    className="text"
                    style={{ backgroundColor: 'rgb(140 198 62)' }}
                  >
                    Management Reports
                  </div>
                </div>
              </Grid>
            )}
            {roles.indexOf('Settings') > -1 && (
              <Grid size={{ sm: 6, md: 3 }}>
                <div
                  className="card"
                  onClick={() => navigate('/home/settings')}
                >
                  <SettingsIcon
                    style={{ fontSize: 198, color: 'rgb(40 56 144)' }}
                  />
                  <div
                    className="text"
                    style={{ backgroundColor: 'rgb(40 56 144)' }}
                  >
                    Settings
                  </div>
                </div>
              </Grid>
            )}
          </Grid>
        )}
        {isAdmin === true && (
          <Grid container spacing={3} justifyContent="center">
            <Grid size={{ sm: 6, md: 3 }}>
              <div
                className="card"
                onClick={() => navigate('/home/admin')}
              >
                <img src={img1} className="img" alt="img1" />
                <div className="text">Admin</div>
              </div>
            </Grid>
            <Grid size={{ sm: 6, md: 3 }}>
              <div
                className="card"
                onClick={() => navigate('/home/managetempdb')}
              >
                <img src={img1} className="img" alt="img2" />
                <div className="text">Manage TempDB</div>
              </div>
            </Grid>
            <Grid size={{ sm: 6, md: 3 }}>
              <div
                className="card"
                onClick={() => navigate('/home/pkgmanage')}
              >
                <img src={img1} className="img" alt="img3" />
                <div className="text">Package Management</div>
              </div>
            </Grid>
          </Grid>
        )}
      </Container>
    </div>
  );
};

export default MainPage;
